import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import ErrorPage from './Pages/404Page'
import Home from './Pages/Home'
import WelcomePage from './Pages/WelcomePage'
import Form from './Pages/Form'
import SubmitPage from './Pages/SubmitPage'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require('./Config/content.json').en
        },
        hi: {
            translation: require('./Config/content.json').hi
        }
    },
    lng: 'en'
})

function App() {
    return (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={<Home />}
                />
                <Route
                    path="/survey"
                    element={<Form />}
                />
                {/* <Route path="/surveyPage" element={<SurveyPage />} /> */}
                <Route
                    path="/submit"
                    element={<SubmitPage />}
                />
                <Route
                    path="/thanks"
                    element={<WelcomePage />}
                />
                <Route
                    path="*"
                    element={<ErrorPage />}
                />
            </Routes>
        </Router>
    )
}

export default App
